import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import styles from "./ArticleMasthead.module.scss";
import { Container } from "../../Container/Container/Container";
import { LinksBar } from "../../LinksBar/LinksBar";
import { SidebarLayout } from "../../Layout/SidebarLayout/SidebarLayout";
import { SocialBlockArticle } from "../../Block/SocialBlockArticle/SocialBlockArticle";
import { Text } from "../../Text/Text/Text";
import { Theme } from "../../Background/Theme/Theme";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var defaultMainLayoutWithSidebar = false;
export var ArticleMasthead = function ArticleMasthead(_ref) {
  var _ref$byLine = _ref.byLine,
    byLine = _ref$byLine === void 0 ? '' : _ref$byLine,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    linksBar = _ref.linksBar,
    _ref$section = _ref.section,
    section = _ref$section === void 0 ? '' : _ref$section,
    _ref$published = _ref.published,
    published = _ref$published === void 0 ? '' : _ref$published,
    _ref$reviewer = _ref.reviewer,
    reviewer = _ref$reviewer === void 0 ? '' : _ref$reviewer,
    social = _ref.social,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? '' : _ref$subheading,
    _ref$updated = _ref.updated,
    updated = _ref$updated === void 0 ? '' : _ref$updated,
    _ref$mainLayoutWithSi = _ref.mainLayoutWithSidebar,
    mainLayoutWithSidebar = _ref$mainLayoutWithSi === void 0 ? defaultMainLayoutWithSidebar : _ref$mainLayoutWithSi;
  var renderContent = function renderContent() {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [!linksBar && section && /*#__PURE__*/_jsx("div", {
        className: styles.section,
        children: section
      }), linksBar && /*#__PURE__*/_jsx("div", {
        className: styles.breadcrumbs,
        children: /*#__PURE__*/_jsx(LinksBar, _objectSpread({}, linksBar))
      }), headline && /*#__PURE__*/_jsx(Text, {
        className: styles.headline,
        typog: "headline2",
        ariaLevel: 1,
        children: headline
      }), subheading && /*#__PURE__*/_jsx(Text, {
        className: styles.subheading,
        typog: "bodycopyLarge",
        children: subheading
      }), (byLine || reviewer) && /*#__PURE__*/_jsxs("div", {
        className: styles.byline,
        children: [byLine && /*#__PURE__*/_jsx(Text, {
          richText: true,
          textElement: "span",
          typog: "bodycopyLarge",
          children: byLine
        }), byLine && reviewer && /*#__PURE__*/_jsx("span", {
          className: styles.separator,
          children: ' | '
        }), reviewer && /*#__PURE__*/_jsx(Text, {
          richText: true,
          typog: "bodycopyLarge",
          textElement: "span",
          children: reviewer
        })]
      }), (published || updated) && /*#__PURE__*/_jsxs("div", {
        className: styles.date,
        children: [published && /*#__PURE__*/_jsx(Text, {
          richText: true,
          textElement: "span",
          typog: "bodycopySmall",
          children: published
        }), published && updated && /*#__PURE__*/_jsx("span", {
          className: styles.separator,
          children: ' | '
        }), updated && /*#__PURE__*/_jsx(Text, {
          richText: true,
          textElement: "span",
          typog: "bodycopySmall",
          children: updated
        })]
      }), /*#__PURE__*/_jsx(SocialBlockArticle, _objectSpread({}, social))]
    });
  };
  return /*#__PURE__*/_jsx(Theme, {
    theme: "lightBackground",
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(SidebarLayout, {
        main: renderContent(),
        sidebar: mainLayoutWithSidebar ? ' ' : null,
        hideSidebarOnMobile: mainLayoutWithSidebar,
        layout: "article"
      })
    })
  });
};